import Creditor from '@/views/creditor/Details.vue'

const router = {
    path: '/creditors/:creditorId',
    name: 'CreditorDetails',
    component: Creditor,
    meta: {
        title: 'Creditor Details'
    }
  };

export default router
